module.exports = __webpack_public_path__ + "img/Kazakhstan.a0f927ab.png";